import styled from 'styled-components';
import { ThemeProps } from '@/styles/global';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 3.75rem;
  min-width: 18.75rem;
  @media (min-width: 769px) and (max-width: 992px) {
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  }
  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  margin: 0 0 3rem 0;
  font-weight: 500;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  @media (max-width: 678px) {
    font-size: 1.375rem;
    margin: 0 0 1.5rem 0;
  }
`;

export const CategoriesTitle = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
  margin: 0 0 2rem 0;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 80rem;
  @media (max-width: 1140px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ArticlesContainer = styled.div`
  width: 63%;
  max-width: 786px;
  margin-right: 4rem;
  @media (max-width: 1140px) {
    margin: 0;
    width: auto;
  }
`;

export const CategoriesContainer = styled.div`
  width: 34%;
  @media (max-width: 1140px) {
    width: auto;
  }
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

export const TrendingJobsWrapper = styled.div`
  h1 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  p {
    font-size: 0.813rem;
    @media (max-width: 768px) {
      font-size: 0.75rem;
    }
  }
  & > div > div:first-child > div:first-child {
    width: 3rem;
  }
`;
